import { CommonModule, isPlatformBrowser } from "@angular/common";
import {
  Component,
  HostListener,
  inject,
  OnInit,
  PLATFORM_ID,
} from "@angular/core";
import { CommonService } from "../core/services/common.service";
import { ContentLayout } from "./content-layout/content-layout";
import { MenuLayout } from "./menu-layout/menu-layout";
import { PageHeader } from "@app/layouts/page-header/page-header";

@Component({
  selector: "app-layout",
  imports: [MenuLayout, ContentLayout, CommonModule, PageHeader],
  templateUrl: "./layout.html",
  styleUrl: "./layout.scss",
})
export class Layout implements OnInit {
  private readonly commonService = inject(CommonService);
  private readonly platformId = inject(PLATFORM_ID);

  isInitialized = false;
  isMenuCollapsed = false;
  isMobile = false;
  isMenuOpen = false;

  readonly mobileMenuToggleLeft = {
    closed: 16,
    open: 236,
  } as const;

  ngOnInit() {
    this.checkScreenSize();

    this.commonService.isAppInitialized$.subscribe((init) => {
      if (init) {
        this.isInitialized = true;
      }
    });
  }

  @HostListener("window:resize")
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 1024;
      if (!this.isMobile && this.isMenuOpen) {
        this.isMenuOpen = false;
      }
    }
  }

  onMenuToggle(isOpenOrCollapsed: boolean) {
    if (this.isMobile) {
      // For mobile, this parameter indicates if menu should be open
      this.isMenuOpen = isOpenOrCollapsed;
    } else {
      // For desktop, this parameter indicates if menu is collapsed
      this.isMenuCollapsed = isOpenOrCollapsed;
    }
  }

  toggleMobileMenu() {
    if (this.isMobile) {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }

  onBackdropClick() {
    if (this.isMobile && this.isMenuOpen) {
      this.isMenuOpen = false;
    }
  }
}
